import { styled } from '@mui/material';

export const NewsSectionWrap = styled('div')(() => ({
	display: 'grid',
	gap: '24px',
	gridTemplateColumns: '1fr',
}));
